import { ReduxService } from 'dashboard-services/services';

import { codeEditorActions } from 'actions/modules/tools';

export const codeEditorInitialState = {
  id: undefined,
  open: false,
  editable: true,
  newFile: false,
  extension: undefined,
  groupName: undefined,

  title: undefined,
  valueMode: false,
  defaultValue: undefined,
  valueCallback: undefined,
  valueModeType: undefined,

  provider: undefined
}

export default (state = codeEditorInitialState, action) => {

  switch (action.type) {
    case codeEditorActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}